import React from 'react';
import {ServerComponentCaller} from "../../helpers";

const DudasFrecuentes = props => <ServerComponentCaller url={"assets/data/schema/FAQ.json"}/>

export default DudasFrecuentes;
